import { StyledFooter, StyledDialog, StyledDialogContent } from './styles';
import { useTranslation } from 'react-i18next';
import Notification, { INotification } from './Notification';
import { useSideSheet } from '../../contexts/SideSheet';
import { SIDESHEET_CONTENT } from '../../constants';
import {useNotificationStore} from './NotificationStore';
import { useApplications, useUpdateNotification, useUserProfile } from '../../hooks/queries';
import { usePaneManagement } from '../../contexts/PaneManagementContext';
import { useAnalytics } from '../../v2/third-party-integration/amplitude';
import { AMPLITUDE_EVENTS } from '../../constants';
import { TextButton } from '../Buttons/TextButton';
import { useTheme } from '../../contexts/Theme';

const customFooter = (linkAll: string, notificationHandler: Function) => () => {
  const { darkMode } = useTheme();
  return (
    <StyledFooter style={{
      padding: '16px'
    }}>
      <div />
      <TextButton darkMode={darkMode} text={linkAll} onClick={notificationHandler} />
    </StyledFooter>)
}

const NotificationsDialog = (props: {
  isOpen: boolean,
  onClose: Function,
}): JSX.Element => {
  const { t } = useTranslation();
  const { setSideSheetContent } = useSideSheet();
  const { data:applications } = useApplications();
  const { data: userProfile } = useUserProfile();
  const notifications = useNotificationStore((state:any) => state.notifications);
  const read = useNotificationStore((state: any) => state.read);
  const setSelectedNotificationToOpen = useNotificationStore((state: any) => state.setSelectedNotificationToOpen);
  const { mutate: updateNotification } = useUpdateNotification();
  const { openCtaPane } = usePaneManagement();
  const { trackEvent } = useAnalytics();
  const firstNotification = 0;

  const handleNotificationSelect = (notification: INotification) => {
    props.onClose();
    if (!notification.read) {
      updateNotification({ notification, read: true });
      read(notification, true);
    }
    if (notification.ctaUrl) {
      setSideSheetContent(null);
      openCtaPane(notification.ctaUrl);
    } else {
      setSelectedNotificationToOpen(notification);
      setSideSheetContent(SIDESHEET_CONTENT.NOTIFICATION);
    }
    trackEvent(AMPLITUDE_EVENTS.NOTIFICATION_DETAIL, {
      Title: notification?.title,
      Type: notification?.type,
      Action: 'Open',
    });
  };

  return (
    <div>
      <StyledDialog
        isOpen={props.isOpen}
        id="notification-dialog"
        data-testid="notification-dialog"
        onClose={props.onClose}
        title={
          t('notification.dialog.title')
        }
        renderCustomFooterComponent={customFooter(t('notification.dialog.linkAll'), () => {
          setSideSheetContent(SIDESHEET_CONTENT.NOTIFICATION)
          props.onClose();
        })}
      >
        <StyledDialogContent>
          <Notification
                    data-testid={'notification-item'}
                    applications={applications}
                    notification={notifications[firstNotification]}
                    userProfile={userProfile}
                    onSelect={handleNotificationSelect} />
        </StyledDialogContent>
      </StyledDialog>
    </div>
  );
};
export default NotificationsDialog;
